import { DateStr, MissingAudiosReportDto, toDateDiffRange, toDateStr, today } from '@mi-front/core';
import moment from 'moment-timezone';
import { apiClient } from '../../../../../../../../api';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { ReportView } from '../../../../../../../../core/reports/components/ReportView';
import { useStationsFinder } from '../../../../../../../../core/stations/hooks/useStations';
import { MissingAudioReportForm } from './MissingAudioReportForm';
import { MissingAudiosReportEmptyState } from './MissingAudiosReportEmptyState';
import { MissingAudiosReportResult } from './MissingAudiosReportResult';
import { MissingAudiosReport } from './types';
import { Station } from '@app/core/types/stations';

const sortDataByDate = (data: MissingAudiosReportDto) => {
  const orderedData = data?.items?.sort((a, b) => {
    const dateA = moment(a.datetime, 'YYYY-MM-DDTHH:mm:ss.SSSZ');
    const dateB = moment(b.datetime, 'YYYY-MM-DDTHH:mm:ss.SSSZ');
    return dateB.isBefore(dateA) ? -1 : dateB.isAfter(dateA) ? 1 : 0;
  });

  return {
    ...data,
    items: orderedData,
  };
};

export function MissingAudiosReportView(p: { station: Station }) {
  const tz = useTimezone();
  const findStation = useStationsFinder();

  // Last 30 days inclusive (today + previous 29 days), matching date-range presets.
  const resetValues = {
    ...toDateDiffRange(
      toDateStr(moment().tz(tz).subtract(29, 'days')) as DateStr,
      today() as DateStr,
      tz,
    ),
  };

  return (
    <ReportView<MissingAudiosReport>
      defaultValues={resetValues}
      download={{
        local: true,
        filename: 'missing-media',
        resultToExport: (result) =>
          result.items.map((item) => ({
            station: findStation(item.stationId)?.name ?? item.stationId,
            schedule_custom_id: item.customId,
            schedule_date: item.datetime,
          })),
      }}
      reportFn={(values) => {
        return apiClient.audit
          .stationReportsMissingAudios({
            stationId: p.station.slug,
            from: values.from,
            to: values.to,
          })
          .then(sortDataByDate);
      }}
      Form={MissingAudioReportForm}
      Result={MissingAudiosReportResult}
      emptyResult={<MissingAudiosReportEmptyState />}
    />
  );
}
